
import { Observable } from 'rxjs';
import { AssignmentVM, ClassForListing, GradebookVM, StudentVM, UnAssignModel, CreateAssignmentsModel } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';

export class GradebookDataService {
    constructor(private apiService: IAPIService) {

    }

  ShowGradebookStudentAssignmentCreateAssignmentInterface(): Observable<boolean>{
    return this.apiService.ShowGradebookStudentAssignmentPagesCreateAssignmentInterfaces();
  }

  GetClassListByTeacher() : Observable<ClassForListing[]> {
    return this.apiService.GetClassListByTeacher();
  }

  GetLessonProgressByClassID(classID: number) : Observable<GradebookVM> {
    return this.apiService.GetLessonProgressByClassID(classID);
  }

  GetLessonProgressByLessonVersionID(classID: number, lessonVersionId: number) : Observable<AssignmentVM>{
    return this.apiService.GetLessonProgressByLessonVersionID(classID, lessonVersionId);
  }

  ReleaseAllGradesByAssignmentID(requestModel: { Threshold: any; Reassign: any; ClassID: number; ReassignShowIcon: any; ReassignShowAnswer: any; AssignmentID: number; }) : Observable<boolean> {
    return this.apiService.ReleaseAllGradesByAssignmentID(requestModel);
  }

  GetClassListByTeacherAndStudentID(studentID: number) : Observable<ClassForListing[]>{
		return this.apiService.GetClassListByTeacherAndStudentID(studentID);
  }

  GetLessonProgressByStudentAndLessonVersionID(classID: any, studentID: number, lessonVersionID: number) : Observable<StudentVM> {
		return this.apiService.GetLessonProgressByStudentAndLessonVersionID(classID, studentID, lessonVersionID);
  }

  GetLessonProgressByStudentID(classID: any, studentID: number) : Observable<StudentVM> {
		return this.apiService.GetLessonProgressByStudentID(classID, studentID);
  }

  ReleaseAllGradesByStudentID(requestModel: { Threshold: any; Reassign: any; ClassID: number; ReassignShowIcon: any; ReassignShowAnswer: any; StudentID: number; DiagnosticExamID: number }) : Observable<boolean> {
		return this.apiService.ReleaseAllGradesByStudentID(requestModel);
  }

  UnassignOneOrAll(model: UnAssignModel){
    return this.apiService.UnassignOneOrAllAssignments(model);
  }

  //Janak
  CreateAssignments(data: CreateAssignmentsModel ): Observable<boolean> {
    return this.apiService.CreateAssignments(data);
  }

  GetDefaultAssignmentOptions() {
    return this.apiService.GetDefaultAssignmentOptions();
  }

  GetClassesWithStudent() {
    return this.apiService.GetClassesWithStudent();
  }

  GetClassWithStudents(classID: number) {
    return this.apiService.GetClassWithStudents(classID);
  }
}
